<template>
	<f7-page name="ccm-study-plan-day" class="page-bg-render">
		<f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
				{{plannerManager.plannerName}}
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
		<div class="block ">
			<div class="row">
				<div class="col-70 block-title-medium">
					<a href="#" class="item-link" v-on:click="studyPlanMonthPage();">수강코스명</a>					
				</div>
				<div class="col-30 text-align-right" >
					<button class="button button-fill" v-on:click="dashBoardPage();">대시보드</button>
				</div>
			</div>
			<div class="row margin-top" >	
				<ul class="col-100 step-progress">
					<!--
					<li v-bind:class="(plannerManager.studyStep == 'review-sdy') ? 'active':''" v-if="plannerManager.reviewStudyType != 'none'">복습</li>						
					<li v-bind:class="(plannerManager.studyStep == 'unit-sdy') ? 'active':''" >학습</li>
					<li v-bind:class="(plannerManager.studyStep == 'clinic-first-sdy') ? 'active':''"  v-if="plannerManager.clinic1Type != 'none'">클리닉</li>						
					-->
					<li v-bind:class="(plannerManager.studyStep == 'review-sdy') ? 'active':''" v-if="plannerManager.reviewStudyType != 'none'">복습</li>						
					<li v-bind:class="(plannerManager.studyStep == 'unit-sdy') ? 'active':''" >학습</li>
					<li v-bind:class="(plannerManager.studyStep == 'clinic-first-sdy') ? 'active':''"  v-if="plannerManager.clinic1Type != 'none'">클리닉</li>	
				</ul>
			</div>							
			<div class="row" style="clear:both">	
				<div class="col-100 text-align-center block-title-medium">
					<a href="#" class="item-link"  v-if="plannerManager.timesNo > 1" v-on:click="prevTime()">◀</a>
					<a href="#" class="item-link"  v-on:click="studyPlanWeekPage();">
						{{plannerManager.weekNo}}주차-{{plannerManager.timesNo}}차시					
					</a> 
					<a href="#" class="item-link" v-if="plannerManager.maxTimesNo > plannerManager.timesNo" v-on:click="nextTime()">▶</a>
				</div>
			</div>
		</div>	
		<div class="block">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<!-- 복습-->
					<div class="swiper-slide" data-id="review-sdy" v-if="plannerManager.reviewStudyType != 'none'">												
						<div class="list">  
							
							<div class="item-inner"  v-if="reviewStepManager.stepStatus == 'complete'">
								<div class="item-title">
									복습 -  완료 ({{reviewStepManager.incorrectExamCnt}}/{{reviewStepManager.examTotalCnt}})							
								</div>
								<div class="item-after" v-if="reviewStepManager.submitDateTime != ''">{{displayDateTime(reviewStepManager.submitDateTime)}}</div>							
							</div>

							<div class="item-inner"   v-else>
								<div class="item-title">복습 -  미완료 ({{reviewStepManager.incorrectExamCnt}}/{{reviewStepManager.examTotalCnt}})</div>
							</div>
	
							<ul>
								<template v-for="(item, i) in reviewStepManager.examList">
									<li :key="'ii'+i">
										<div class="item-content item-inner">
											<div class="item-title">
													<span class="vertical-align-middle">{{item.clName}}</span>
											</div>
										</div>
									</li>								
									<li :key="'ij'+i">
										<div class="item-content item-inner">
											<div class="item-title">
												<div style="display:flex; flex-direction:row;">
													<div style="white-space:normal; padding:2px;">
														<template v-for="(subItem, j) in item.list">
															<img :key="'jj'+j" class="vertical-align-middle" :src="'static/clinic/incorrect.png'" style="margin-left:4px" v-on:click="setPreviewExamImage(subItem.examKey, subItem.examType)"/>	
														</template>
													</div>
												</div>
											</div>
										</div>							
									</li>						
								</template>									
							</ul>
							<div class="text-align-center">
								<button class="button button-fill"  v-if="reviewStepManager.stepStatus == 'complete'" v-on:click="startStudyReview()">복습 확인</button>
								<button class="button button-fill"  v-else v-on:click="startStudyReview()">복습 시작</button>
							</div>
							<div class="row float-right margin-top-half">
								<button class="button button-fill " v-if="reviewStepManager.stepStatus == 'complete'" v-on:click="nextStepView('unit-sdy');">다음학습</button>
								<button class="button button-fill disabled " v-else >다음학습</button>
							</div>
						</div>						
					</div>
						
					<!--학습-->
					<div class="swiper-slide" data-id="unit-sdy">												
						<div class="list">
							<!-- punit 그룹1-->
							<template v-for="(item, i) in studyStepManager.unitStudyArray">
								<div class="card" :key="'ii'+i">
									<div class="card-header">
										{{item.SUNIT_NAME}} ({{getUnitStudyResultName(item.RESULT_KEY)}}) 
										 <div class="item-after" v-if="item.SUBMIT_DATETIME != null ">{{displayDateTime(item.SUBMIT_DATETIME)}}</div>
									</div>
									<div class="card-content" v-if="item.lectureList != null && item.lectureList.length > 0">
										<div class="list">
											<ul>	
												<template v-for="(lectureItem, j) in item.lectureList">							
													<li :key="'jj'+j">
														<div class="item-content">
															<div class="item-inner">
																<div class="item-title">
																	{{lectureItem.CONCEPT_NAME}}
																	<span v-if="lectureItem.STUDY_LECTURE_KEY > 0">(시청완료)</span>
																</div>
																<div class="item-after">
																	<a class="text-color-primary margin-right" style="white-space: nowrap;" v-on:click="starStudyUnitLecture(i,j)">
																		<i class="f7-icons text-color-purple" style="vertical-align: text-bottom;">arrowtriangle_right_circle</i>							
																	</a>
																</div>
															</div>
														</div>
													</li>
												</template>
											</ul>
										</div>
									</div>							
									<div class="card-content">
										<div class="list">
											<ul>
												<li>
													<div class="item-content item-inner">
														<div class="item-title">
																<span class="vertical-align-middle">{{item.PUNIT_NAME}}</span>															
														</div>													
													</div>
												</li>
												<li>
													<ul>
														<template v-for="(patItem, j) in item.patList">
															<li :key="'jj'+j">
																<div class="item-content">
																	<div class="item-inner">
																		<div class="item-title">{{patItem.PAT_NAME}}</div>
																		<div class="item-after">{{patItem.EXAM_CNT}}문항</div>
																	</div>
																</div>
															</li>
														</template>
													</ul>
												</li>
											</ul>
										</div>
									</div>
									<div class="card-footer">
										<a href="#" class="link" style="position:absolute;right:0;margin-right:10px" v-if="item.RESULT_KEY > 0" v-on:click="startStudyUnit(i)">학습 확인</a>
										<a href="#" class="link" style="position:absolute;right:0;margin-right:10px" v-else v-on:click="startStudyUnit(i)">학습 시작</a>
									</div>
								</div>
							</template>					
							<div class="row float-left margin-top-half">
								<button class="button button-fill " v-if="plannerManager.timesNo > 1 && plannerManager.reviewStudyType != 'none' && reviewStepManager.examList.length > 0 " v-on:click="prevStepView('review-sdy');">이전학습</button>								
							</div>
							<div class="row float-right margin-top-half">
								<button class="button button-fill " v-if="studyStepManager.stepStatus == 'complete' && plannerManager.clinic1Type != 'none' " v-on:click="nextStepView('clinic-first-sdy');">다음학습</button>
								<button class="button button-fill disabled " v-else >다음학습</button>
							</div>
						</div>	
					</div>

					<!--클리닉-->
					<div class="swiper-slide" data-id="clinic-first-sdy" v-if="plannerManager.clinic1Type != 'none'">				
						<!--1차-->
						<div class="list">
							
							<div class="item-inner"  v-if="clinicStepManager.firstClinic.stepStatus == 'complete'">
								<div class="item-title">
									1차 클리닉 - 완료 ({{clinicStepManager.firstClinic.incorrectExamCnt}}/{{clinicStepManager.firstClinic.examTotalCnt}})			
								</div>
								<div class="item-after" v-if="clinicStepManager.firstClinic.submitDateTime != '-' ">
									{{displayDateTime(clinicStepManager.firstClinic.submitDateTime)}}
								</div>							
							</div>

							<div class="item-inner"  v-else>
								<div class="item-title">
									1차 클리닉 - 미완료 ({{clinicStepManager.firstClinic.incorrectExamCnt}}/{{clinicStepManager.firstClinic.examTotalCnt}})
								</div>
							</div>						

							<ul>
								<template v-for="(item, i) in clinicStepManager.firstClinic.examList">
									<li :key="'ii'+i">
										<div class="item-content item-inner">
											<div class="item-title">
													<span class="vertical-align-middle">{{item.clName}}</span>
											</div>
										</div>
									</li>
									<li :key="'ij'+i">
										<div class="item-content item-inner">
											<div class="item-title">
												<div style="display:flex; flex-direction:row;">
													<div style="white-space:normal; padding:2px;">
														<template v-for="(subItem, j) in item.list">
															<img :key="'jj'+j" class="vertical-align-middle" :src="'static/unit/lv2.png'" style="margin-left:4px" v-on:click="setPreviewExamImage(subItem.examKey, subItem.examType)"/>													
														</template>
													</div>
												</div>
											</div>
										</div>		
									</li>
								</template>
							</ul>
							<div class="text-align-center">
								<button class="button button-fill" v-if="clinicStepManager.firstClinic.stepStatus == 'complete'" v-on:click="startStudyFirstClinic()">1차 클리닉 학습확인</button>
								<button class="button button-fill" v-else v-on:click="startStudyFirstClinic()">1차 클리닉 학습시작</button>
							</div>
						</div>	

						<!--2차-->
						<div class="list" v-if="plannerManager.clinic2Type != 'none' && clinicStepManager.secondClinic.examList.length > 0">										
							<div class="item-inner"  v-if="clinicStepManager.firstClinic.stepStatus == 'complete'">
								<div class="item-title">
									2차 클리닉 - 완료 ({{clinicStepManager.secondClinic.incorrectExamCnt}}/{{clinicStepManager.secondClinic.examTotalCnt}})			
								</div>
								<div class="item-after" v-if="clinicStepManager.secondClinic.submitDateTime != '-' ">
									{{displayDateTime(clinicStepManager.secondClinic.submitDateTime)}}
								</div>							
							</div>

							<div class="item-inner"  v-else>
								<div class="item-title">
									2차 클리닉 - 미완료 ({{clinicStepManager.secondClinic.incorrectExamCnt}}/{{clinicStepManager.secondClinic.examTotalCnt}})
								</div>
							</div>	

							<ul>
								<template v-for="(item, i) in clinicStepManager.secondClinic.examList">
									<li :key="'ii'+i">
										<div class="item-content item-inner">
											<div class="item-title">
													<span class="vertical-align-middle">{{item.clName}}</span>
											</div>
										</div>
									</li>
									<li :key="'ij'+i">
										<div class="item-content item-inner">
											<div class="item-title">
												<div style="display:flex; flex-direction:row;">
													<div style="white-space:normal; padding:2px;">
														<template v-for="(subItem, j) in item.list">
															<img :key="'jj'+j" class="vertical-align-middle" :src="'static/unit/lv2.png'" style="margin-left:4px" v-on:click="setPreviewExamImage(subItem.examKey, subItem.examType)"/>													
														</template>
													</div>
												</div>
											</div>
										</div>		
									</li>
								</template>
							</ul>
							<div class="text-align-center">
								<button class="button button-fill" v-if="clinicStepManager.secondClinic.stepStatus == 'complete'" v-on:click="startStudySecondClinic()">2차 클리닉 학습확인</button>
								<button class="button button-fill" v-else v-on:click="startStudySecondClinic()">2차 클리닉 학습시작</button>
							</div>
						</div>	
						<div class="row float-left margin-top-half">
							<button class="button button-fill" v-on:click="prevStepView('unit-sdy');">이전학습</button>								
						</div>						
					</div>
				</div>
			</div>
		</div>

		<!--문항 이미지 팝업-->
	<div class="popup exam-perview-popup">
		<div class="view">
			<div class="page">
				<div class="navbar">
					<div class="navbar-bg"></div>
					<div class="navbar-inner">
						<div class="title">문항 미리보기</div>
						<div class="right">
							<!-- Link to close popup -->
							<a class="link popup-close">닫기</a>
						</div>
					</div>
				</div>
				<div class="page-content">
					<div class="block block-strong">	
						<img :src="imgExamSrc" width="100%" style="margin-bottom:10px;"/>
						<img :src="imgExamViewSrc" width="100%" v-if="imgExamViewSrc != '' "/>				
					</div>
				</div>
			</div>
		</div>
	</div>		
	</f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import idpwVue from '../../guest/idpw.vue';

export default {
	data() {
		return {			
			studySwiper: undefined,						
			imgExamSrc : "",
			imgExamViewSrc : "",	
			loginFlg : false,	
			swiperIndexArray: [],
			swiperIndexNo : 0,
			touchFlg : false,		
			studyArrayIndex : 0,
			plannerManager: {
				gradeId: "",
				reviseId: "", 
				semesterId: "",			
				groupKey: 0,
				plannerName: "",
				plannerKey: 0, //현재 수강Key
				studyStep: "", //현재스탭
				timesNo: 0, //현재 차시	
				maxTimesNo : 0, //max 차시
				weekNo:0, //현재 주차 
				startDate: "",//현재주에 시작 날짜			
				endDate: "", //현재주에 마지막 날짜
				reviewStudyType: "", //복습
				patTypes: "", //문제 풀이
				clinic1Type: "",//1차 클리닉
				clinic2Type: "",//2차 클리닉
				timesPerWeek:0, // 1주에 몇차시
				diffPercent: {
					d1Percent : 0,
					d2Percent : 0,
					d3Percent : 0,
					d4Percent : 0
				},
				indexKey:0
			},
			reviewStepManager: {
				stepStatus: "",
				submitDateTime: "",
				examTotalCnt: 0,
				incorrectExamCnt:0,	
				resultKey: 0,			
				examList: []								
			},
			studyStepManager: {
				stepStatus: "",
				examTotalCnt: 0,
				unitStudyArray: []
			},
			clinicStepManager: {				
				firstClinic: {
					stepStatus : "",
					examTotalCnt: 0,
					submitDateTime: "",
					incorrectExamCnt:0,	
					resultKey: 0,			
					examList: []
				},
				secondClinic: {
					stepStatus : "",
					examTotalCnt: 0,
					submitDateTime: "",
					incorrectExamCnt:0,	
					resultKey: 0,		
					examList: []
				}			
			}
		}
	},

	mounted() {
		const _this = this;		
				
	 	//임시 	
		try {
			_this.plannerManager.plannerKey = _this.$f7route.context.plannerKey;
			_this.plannerManager.gradeId = _this.$f7route.context.gradeId;
			_this.plannerManager.semesterId = _this.$f7route.context.semesterId;
			_this.plannerManager.reviseId = _this.$f7route.context.reviseId;
			_this.plannerManager.groupKey = _this.$f7route.context.groupKey;	
			_this.plannerManager.timesNo = _this.$f7route.context.timesNo;		

			if( _this.$f7route.context.loginFlg != undefined) {
				_this.loginFlg = _this.$f7route.context.loginFlg;
			}

			if(_this.loginFlg) {
				_this.plannerManager.studyStep = _this.$f7route.context.studyStep;
			}
						

		} catch (e) {
			_this.plannerManager.plannerKey = 30;
			_this.plannerManager.gradeId = 'e4';
			_this.plannerManager.semesterId = 's1';
			_this.plannerManager.reviseId = '2015'
			_this.plannerManager.groupKey = 0;	
			_this.plannerManager.studyStep = "";			
			_this.loginFlg = false;
		}

		_this.loadStudyPlanDay();	
		$(document).on('page:reinit', '.page[data-name="ccm-study-plan-day"]', _this.onPageReload);
		
		$(document).on('page:beforeremove', '.page[data-name="ccm-study-plan-day"]', function(e) {
				$(document).off('page:reinit', '.page[data-name="ccm-study-plan-day"]');
		});
	
	},

	methods: {
		onPageReload(e){
			const _this = this;
			var page = e.detail;
			
			if(page.direction == "backward") {

				var returnObj = PAGES.getReturnObj();	

				if(returnObj != undefined) {
					_this.setStepView(returnObj.code);
				} else {
					_this.setStepView();
				}
			}			
		},	
		loadStudyPlanDay() {
			const _this = this;
			
			_this.initObject();

			let param = {
				plannerKey: _this.plannerManager.plannerKey,
				gradeId: _this.plannerManager.gradeId,
				semesterId: _this.plannerManager.semesterId,
				reviseId: _this.plannerManager.reviseId,	
				weekNo: _this.plannerManager.weekNo,			
				timesNo: _this.plannerManager.timesNo
			};

			API.ajaxRequest({
				url: API.getStudyPlanDayUrl(),
				data:param
			}).then(function (data) {
																								
				var plannerInfo = _this.plannerManager;				
				plannerInfo.weekNo = data.weekNo;
				plannerInfo.timesNo = data.timesNo;
				plannerInfo.groupKey = data.groupKey;
				plannerInfo.startDate = data.startDate;
				plannerInfo.endDate = data.endDate;	
				plannerInfo.plannerName = data.plannerInfo.PLANNER_NAME;
				plannerInfo.reviewStudyType = data.plannerInfo.RESTUDY_TYPES;
				plannerInfo.patTypes = data.plannerInfo.PAT_TYPES;
				plannerInfo.clinic1Type = data.plannerInfo.CLINIC1_TYPE;				
				plannerInfo.clinic2Type = data.plannerInfo.CLINIC2_TYPE;
				plannerInfo.timesPerWeek = data.plannerInfo.TIMES_PER_WEEK;
				plannerInfo.diffPercent.d1Percent = data.plannerInfo.D1_PERCENT;
				plannerInfo.diffPercent.d2Percent = data.plannerInfo.D2_PERCENT;
				plannerInfo.diffPercent.d3Percent = data.plannerInfo.D3_PERCENT;
				plannerInfo.diffPercent.d4Percent = data.plannerInfo.D4_PERCENT;
				plannerInfo.maxTimesNo = plannerInfo.timesPerWeek * data.plannerInfo.WEEKS;				
				
				if(plannerInfo.reviewStudyType != "none" && plannerInfo.clinic1Type != "none") {
				
					_this.swiperIndexArray[0] = CONST.studyStepType["review-sdy"].id;
					_this.swiperIndexArray[1] = CONST.studyStepType["unit-sdy"].id;
					_this.swiperIndexArray[2] = CONST.studyStepType["clinic-first-sdy"].id;

				} else if(plannerInfo.reviewStudyType != "none" && plannerInfo.clinic1Type == "none") {

					_this.swiperIndexArray[0] = CONST.studyStepType["review-sdy"].id;
					_this.swiperIndexArray[1] = CONST.studyStepType["unit-sdy"].id;
				
				} else if(plannerInfo.reviewStudyType == "none" && plannerInfo.clinic1Type != "none") {

					_this.swiperIndexArray[0] = CONST.studyStepType["unit-sdy"].id;
					_this.swiperIndexArray[1] = CONST.studyStepType["clinic-first-sdy"].id;
	
				} else {				
					_this.swiperIndexArray[0] = CONST.studyStepType["unit-sdy"].id;				
				}
				
				if(_this.loginFlg) {
					_this.loginFlg = false;
				}else{
					
					if(plannerInfo.reviewStudyType != "none") {	
						plannerInfo.studyStep = CONST.studyStepType["review-sdy"].id;
					} else {			
						plannerInfo.studyStep = CONST.studyStepType["unit-sdy"].id;
					} 

				}

				_this.setStepView();
										
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},
		initObject() {
			const _this = this;			
			_this.imgExamSrc = "";
			_this.imgExamViewSrc = "";				

			_this.reviewStepManager = {
				stepStatus: "",
				submitDateTime: "",
				examTotalCnt: 0,
				incorrectExamCnt:0,	
				resultKey: 0,			
				examList: []			
			};

			_this.studyStepManager = {
				stepStatus: "",
				examTotalCnt: 0,
				unitStudyArray: []
			};

			_this.clinicStepManager = {
				firstClinic: {
					stepStatus : "",
					submitDateTime: "",
					examTotalCnt: 0,
					incorrectExamCnt:0,	
					resultKey: 0,			
					examList: []
				},
				secondClinic: {
					stepStatus : "",
					submitDateTime: "",
					examTotalCnt: 0,
					incorrectExamCnt:0,	
					resultKey: 0,		
					examList: []
				}			
			};

			if(_this.studySwiper == null || _this.studySwiper == undefined) {
				
				_this.studySwiper = _this.$f7.swiper.create('.swiper-container', {
						speed: 400,
						spaceBetween: 100,
						touchStartForcePreventDefault: true,												
						on : {
							touchMove(event) {						
								_this.touchFlg = true;
							},						
							slideChangeTransitionEnd: function() {																		
								if(_this.touchFlg) {
									_this.plannerManager.studyStep = _this.swiperIndexArray[this.realIndex];
									_this.setStepView("swiping");									
								}

								_this.touchFlg = false;
							}						
						}				
				});		

			};	
			
			_this.studySwiper.allowSlidePrev = true;
			_this.studySwiper.allowSlideNext = true;
			_this.studySwiper.slideTo(0);

		},
		setStepView(code) {
			const _this = this;
		
			var plannerInfo = _this.plannerManager;
			console.log(plannerInfo.studyStep);// 디버깅 alert
			if(plannerInfo.studyStep == CONST.studyStepType["review-sdy"].id) {
				_this.getStudyReviewInfo(code);	
			} else if(plannerInfo.studyStep == CONST.studyStepType["unit-sdy"].id) {	
				_this.getStudyUnitInfo(code);
			} else if(plannerInfo.studyStep ==  CONST.studyStepType["clinic-first-sdy"].id) {	
				_this.getStudyFirsrClinicInfo(code);	
			} else {
				alert("no study step"); // 디버깅 alert
			}

		},
		getStudyReviewInfo(code) {
			const _this = this;
						
			var reviewStudyTyps = MODULE.Util.splitGroupValue(_this.plannerManager.reviewStudyType);
			var timesNoArray = [];
			
			for (var i = 0; i < reviewStudyTyps.length; i++) {
				
				var type = reviewStudyTyps[i];
							
				if(type == "prevtime") { //이전 차시 
					
					if( (_this.plannerManager.timesNo - 1) > 0) {
						timesNoArray[i] = _this.plannerManager.timesNo - 1;						
					}

				} else if(type == "prevweek") { //전주 차시
					
					if( (_this.plannerManager.timesNo - _this.plannerManager.timesPerWeek) > 0) {
						timesNoArray[i] = _this.plannerManager.timesNo - _this.plannerManager.timesPerWeek;			
					}

				}
			}

			let param = {
				groupKey : _this.plannerManager.groupKey,
				plannerKey: _this.plannerManager.plannerKey,						
				timesNo : _this.plannerManager.timesNo,				
				prevTimesArray : timesNoArray
			};		

			API.jsonRequest({
				url: API.getStudyReviewInfoUrl(),  
				data: param
			}).then(function (data) {	
								
				_this.reviewStepManager.resultKey = data.resultKey;
				_this.reviewStepManager.submitDateTime = data.submitDateTime;
				_this.reviewStepManager.stepStatus = data.stepStatus;				
				_this.reviewStepManager.examTotalCnt = data.examTotalCnt;
				_this.reviewStepManager.incorrectExamCnt = data.incorrectExamCnt;
				_this.reviewStepManager.examList = data.examList;
  
				if(_this.reviewStepManager.examList.length == 0 
						|| _this.reviewStepManager.examList == null) {										

					_this.reviewStepManager.stepStatus = "complete";
					_this.plannerManager.studyStep = CONST.studyStepType["unit-sdy"].id;											
					_this.setStepView();	
					return;										
				} 
				
				if(code == CONST.studyResultStatus["complete"].id
						&& _this.reviewStepManager.stepStatus == "complete"){

						MODULE.DialogBox.timerDialog(
							"알림",
							"다음 학습을 진행 하시겠습니까?",
							function() {
								_this.plannerManager.studyStep = CONST.studyStepType["unit-sdy"].id;
								_this.setStepView();					
							},
							function() { //cancel

							}						
						);
						
				}

				_this.setSwiperRender(code);

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},
		getStudyUnitInfo(code) {
			const _this = this;						

			let param = {				
				groupKey :  _this.plannerManager.groupKey,
				plannerKey : _this.plannerManager.plannerKey,
				weekNo : _this.plannerManager.weekNo,
				timesNo : _this.plannerManager.timesNo
			};

				API.ajaxRequest({
				url: API.getStudyUnitInfoUrl(),
				data:param
			}).then(function (data) {	

				_this.studyStepManager.unitStudyArray = data.unitStudyArray;
				
				//유닛학습이 완료 됐다는 시그널을 받고 , 클리닉 학습이 없다면 차시 완료 마킹 
				if(_this.studyStepManager.stepStatus == "none" 
					&& data.stepStatus == "complete"
					&& _this.plannerManager.clinic1Type == "none") 
				{
					_this.setCompleteStudyTimes();	
					return;					
				}				
				
				_this.studyStepManager.stepStatus = data.stepStatus;
		
				if(_this.studyStepManager.stepStatus == "complete" && _this.plannerManager.clinic1Type != 'none') {	
					
					if(code == "complete") {
						MODULE.DialogBox.timerDialog(
							"알림",
							"클리닉 학습을 진행 하시겠습니까?",
							function() {
								_this.plannerManager.studyStep = CONST.studyStepType["clinic-first-sdy"].id;	
								_this.setStepView();					
							},
							function() { //cancel

							}											
						);
					}				
				} else {				
					
					if(code == "complete") {						
						//다음 학습이 있는지 체크 
						_this.checkNextStudy();												
					}

				}

				_this.setSwiperRender(code);
				
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});


		},
		getStudyFirsrClinicInfo(code) {
			const _this = this;
		
			let param = {
				groupKey: _this.plannerManager.groupKey,
				plannerKey : _this.plannerManager.plannerKey,
				weekNo : _this.plannerManager.weekNo,
				timesNo : _this.plannerManager.timesNo				
			};

			API.ajaxRequest({
				url: API.getStudyFirstClinicInfoUrl(),
				data:param
			}).then(function (data) {
			
				var firstManager = _this.clinicStepManager.firstClinic;
				
				//2차 클리닉이 없고 , 완료 했다는 시그널을 받으면 차시완료 마킹 
				if(firstManager.stepStatus == "none" 
					&& data.stepStatus == "complete"
					&& _this.plannerManager.clinic2Type == "none") {
						_this.setCompleteStudyTimes();
				}
								
				firstManager.resultKey = data.resultKey;
				firstManager.stepStatus = data.stepStatus;		
				firstManager.submitDateTime = data.submitDateTime;		
				firstManager.examTotalCnt = data.clinicTotalCnt;
				firstManager.incorrectExamCnt = data.incorrectClinicCnt;
				firstManager.examList = data.clinicList;

				if(_this.plannerManager.clinic2Type != "none"
					&& firstManager.stepStatus  == "complete") {
					_this.getStudySecondClinicInfo(code);
				}

				_this.setSwiperRender(code);

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},
		getStudySecondClinicInfo(code) {
			const _this = this;

			let param = {
				groupKey: _this.plannerManager.groupKey,
				plannerKey : _this.plannerManager.plannerKey,
				weekNo : _this.plannerManager.weekNo,
				timesNo : _this.plannerManager.timesNo				
			};

			API.ajaxRequest({
				url: API.getStudySecondClinicInfoUrl(),
				data:param
			}).then(function (data) {				
				var secondManager = _this.clinicStepManager.secondClinic;
				
				//완료 했다는 시그널을 받으면 차시완료 마킹 
				if(secondManager.stepStatus == "none" 
					&& data.stepStatus == "complete"
				) {
						_this.setCompleteStudyTimes();   
				}
								
				secondManager.resultKey = data.resultKey;
				secondManager.stepStatus = data.stepStatus;		
				secondManager.submitDateTime = data.submitDateTime;				
				secondManager.examTotalCnt = data.clinicTotalCnt;
				secondManager.incorrectExamCnt = data.incorrectClinicCnt;
				secondManager.examList = data.clinicList;

				if(code == CONST.studyResultStatus["complete"].id
					&& _this.clinicStepManager.firstClinic.stepStatus == CONST.studyResultStatus["complete"].id
					&& secondManager.stepStatus == "none" 
				) {

					MODULE.DialogBox.timerDialog(
						"알림",
						"2차 클리닉을 학습 하시겠습니까?",
						function() {
							_this.startStudySecondClinic();					
						},
						function() { },
						5																		
					);
				}

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},	
		setSwiperRender(code){
			const _this = this;
			var plannerInfo = _this.plannerManager;
			
			_this.studySwiper.allowSlidePrev = true;
			_this.studySwiper.allowSlideNext = true;

			var swiperIndexNo = 0; 

			if(code != "swiping") {

				for(var i = 0; _this.swiperIndexArray.length; i++) {

					if(plannerInfo.studyStep == _this.swiperIndexArray[i]) {
						swiperIndexNo = i;
						break;
					}
				}
				_this.studySwiper.slideTo(swiperIndexNo);
			}


			if(plannerInfo.studyStep == CONST.studyStepType["review-sdy"].id) {

				if(_this.reviewStepManager.stepStatus == "complete") {
					_this.studySwiper.allowSlideNext = true;
				} else {
					_this.studySwiper.allowSlideNext = false;
				}					
			
			} else if(plannerInfo.studyStep == CONST.studyStepType["unit-sdy"].id) {	
				
				//prev 슬라이드 가능 여부 
				if(_this.reviewStepManager.stepStatus == "complete" 
						&& plannerInfo.reviewStudyType != "none" ) {
					
					if(_this.reviewStepManager.examList != null 
						&& _this.reviewStepManager.examList.length > 0){
						_this.studySwiper.allowSlidePrev = true;		
					} else {
						_this.studySwiper.allowSlidePrev = false;
					}

				} else {
					_this.studySwiper.allowSlidePrev = false;
				}
								
				//next 슬라이드 가능 여부 
				if(_this.studyStepManager.stepStatus == "complete" 
						&& plannerInfo.clinic1Type != "none") {
					_this.studySwiper.allowSlideNext = true;
				} else {
					_this.studySwiper.allowSlideNext = false;
				}
					
			
			} else if(plannerInfo.studyStep ==  CONST.studyStepType["clinic-first-sdy"].id) {		
				
				if(_this.studyStepManager.stepStatus == "complete") {
					_this.studySwiper.allowSlideNext = true;
				} else {
					_this.studySwiper.allowSlideNext = false;
				}				
			
			} else {
				alert("no study step"); // 디버깅 alert
			}

			$('.page-content').scrollTop(0);

		},
		nextStepView(studyStepId){		  
			const _this = this;				
			_this.plannerManager.studyStep =	CONST.studyStepType[studyStepId].id;	
			_this.setStepView();
			
		},
		prevStepView(studyStepId){
			const _this = this;	
			_this.plannerManager.studyStep =	CONST.studyStepType[studyStepId].id;	
			_this.setStepView();						
		
		},
		prevTime(){
			const _this = this;

			if(_this.plannerManager.timesNo > 1) {
				_this.plannerManager.timesNo -= 1;				
				_this.loadStudyPlanDay();
			}
		},
		nextTime(){
			const _this = this;

			if(_this.plannerManager.maxTimesNo > _this.plannerManager.timesNo) {
				_this.plannerManager.timesNo += 1;				
				_this.loadStudyPlanDay();
			}
		},	 
		setCompleteStudyTimes() {
			const _this = this;		

			let param = {				
				gradeId : _this.plannerManager.gradeId,
				reviseId : _this.plannerManager.reviseId,
				semesterId : _this.plannerManager.semesterId,
				groupKey :  _this.plannerManager.groupKey,
				plannerKey : _this.plannerManager.plannerKey,
				weekNo : _this.plannerManager.weekNo,
				timesNo : _this.plannerManager.timesNo
			};
			
			API.ajaxRequest({
				url: API.setCompleteStudyTimesUrl(),
				data: param
			}).then(function (data) {				
				MODULE.DialogBox.message("알림","모든 학습이 완료 되었습니다.");
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});  

		},
		startStudyReview() {
			const _this = this;
			var array = _this.getStudyReviewLinkExamList();
			var url = PAGES.SUB_CCM_STUDY_PLAN_REVIEW_APPLY;

			var param = {
				plannerInfo: _this.plannerManager,
				resultKey : _this.reviewStepManager.resultKey,			
				linkExamArray: array
			}

			PAGES.popPage(url,param);
		},
		getStudyReviewLinkExamList() {
			const _this = this;

			var array = [];
  
			for (var i = 0; i < _this.reviewStepManager.examList.length; i++) {
				var objList = _this.reviewStepManager.examList[i];

				for(var j = 0; j < objList.list.length; j++) {
					var item  = objList.list[j];
					array.push(item);
				}
			}

			return array;  
		},
		starStudyUnitLecture(studyIndex, lectureIndex) {
			const _this = this;
				
			var lectureItem = _this.studyStepManager.unitStudyArray[studyIndex].lectureList[lectureIndex];
			
			if(lectureItem.STUDY_LECTURE_KEY == 0 || MODULE.Util.isEmpty(lectureItem.STUDY_LECTURE_KEY)) {

				let param = {				
					groupKey :  _this.plannerManager.groupKey,
					plannerKey : _this.plannerManager.plannerKey,				
					timesNo : _this.plannerManager.timesNo,

					sunitKey :  lectureItem.SUNIT_KEY,
					punitKey : lectureItem.PUNIT_KEY,
					conceptKey : lectureItem.CONCEPT_KEY,
					lectureKey : lectureItem.LECTURE_KEY			
				};				
				
				API.ajaxRequest({
					url: API.saveStudyUnitLectureUrl(),
					data:param
				}).then(function (data) {		
					
					if(lectureItem.STUDY_LECTURE_KEY == 0 || MODULE.Util.isEmpty(lectureItem.STUDY_LECTURE_KEY)) {
						lectureItem.STUDY_LECTURE_KEY = data.studyLectureKey;									
					}	

					AUTH.savePlanStudyInfo(_this.plannerManager);
					
					_this.studyArrayIndex = studyIndex;	
					_this.checkNextStudy();
				}).catch(function (code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});

			}

		},
		startStudyUnit(studyIndex){
			const _this = this;

			//개념강의 가 있으면 시청완료 다 했는지 체크 후 학습 시작 가능하게 
			var item = _this.studyStepManager.unitStudyArray[studyIndex];
			if(item.lectureList != null && item.lectureList.length > 0) {
				var check = true;

				for(var i = 0; i < item.lectureList.length; i++) {
					var lectureItem = item.lectureList[i];

					if(lectureItem.STUDY_LECTURE_KEY == 0 || MODULE.Util.isEmpty(lectureItem.STUDY_LECTURE_KEY)) {
						check = false;
						break;
					}

				}

				if(!check) {
					MODULE.DialogBox.message("알림", "모든 개념강의 시청을 하셔야 학습이 가능합니다.");
					return;
				}
				
			} 

			var array = _this.getStudyUnitPatList(item);
			var totalCnt = _this.getStudyUnitExamCount(item);
			var url = PAGES.SUB_CCM_STUDY_PLAN_UNIT_APPLY;

			var param = {			
				plannerInfo: _this.plannerManager,				
				studyName : item.PUNIT_NAME,			
				sunitKey : item.SUNIT_KEY,
				punitKey : item.PUNIT_KEY,
				resultKey : item.RESULT_KEY,				
				patInfoArray: array,
				totalCnt : totalCnt						
			}
			
			_this.studyArrayIndex = studyIndex;	
			PAGES.popPage(url,param);

		},
		getStudyUnitPatList(item) {
			const _this = this;

			var array = [];

			for(var i = 0; i < item.patList.length; i++) {
				var subItem = item.patList[i];
				var patInfo = new Object;

				patInfo.patKey = subItem.PAT_KEY;
				patInfo.examCnt = subItem.EXAM_CNT;				

				array.push(patInfo);
			} 
					
			return array;  
		},
		getStudyUnitExamCount(item) {
			const _this = this;
			var cnt = 0;

			for(var i = 0; i < item.patList.length; i++) {
				var subItem = item.patList[i];
				
				cnt += subItem.EXAM_CNT;
			} 

			return cnt;
		},
		checkNextStudy() {
			const _this = this;			

			try {				
				var index = _this.studyArrayIndex;		
															
				if(index >= 0 && index < _this.studyStepManager.unitStudyArray.length - 1) {
				
					outer : for(var i = index; i < _this.studyStepManager.unitStudyArray.length; i++) {
										var item = _this.studyStepManager.unitStudyArray[i];
									
										for(var j = 0; j < item.lectureList.length; j++) {
											var lectureItem = item.lectureList[j];

											if(lectureItem.STUDY_LECTURE_KEY == 0 
												|| MODULE.Util.isEmpty(lectureItem.STUDY_LECTURE_KEY)) {
												
												MODULE.DialogBox.timerDialog(
													"알림",
													"다음 개념강의 시청을 하시겠습니까?",
													function() {
														_this.starStudyUnitLecture(i, j);
													},
													function() { },
													5																		
												);																								
												break outer;
											}
										
										} //end lecture for

										if(item.RESULT_KEY == 0 || item.RESULT_KEY == undefined) {
											
											MODULE.DialogBox.timerDialog(
												"알림",
												"다음 학습을 진행 하시겠습니까?",
												function() {
													_this.startStudyUnit(i);			
												},
												function() { },
												5																		
											);				
											break;
										}

									} //end outer for
				}

			} catch (e) {
				console.log(e);
			}		
		},
		startStudyFirstClinic() {
			const _this = this;
			var clinic = _this.clinicStepManager.firstClinic;
			var array = _this.getStudyClinicLinkExamList(clinic.examList);
			var url = PAGES.SUB_CCM_STUDY_PLAN_CLINIC_APPLY;

			var param = {
				plannerInfo: _this.plannerManager,
				clinicStudyType : _this.plannerManager.clinic1Type,
				clinicViewType : CONST.studyStepType["clinic-first-sdy"].id,				
				resultKey : clinic.resultKey,			
				linkExamArray: array				
			}

			PAGES.popPage(url,param);
		},
		startStudySecondClinic() {
			const _this = this;
			
			var clinic = _this.clinicStepManager.secondClinic;
			var array = _this.getStudyClinicLinkExamList(clinic.examList);
			var url = PAGES.SUB_CCM_STUDY_PLAN_CLINIC_APPLY;

			var param = {
				plannerInfo: _this.plannerManager,				
				clinicStudyType : _this.plannerManager.clinic2Type,
				clinicViewType : CONST.studyStepType["clinic-second-sdy"].id,				
				resultKey : clinic.resultKey,			
				linkExamArray: array
			}

			PAGES.popPage(url,param);
		},
		getStudyClinicLinkExamList(examList){
			const _this = this;

			var array = [];

			for (var i = 0; i < examList.length; i++) {
				var objList = examList[i];

				for(var j = 0; j < objList.list.length; j++) {
					var item  = objList.list[j];
					array.push(item);
				}
			}

			return array;  
		},
		displayDateTime(dateTime) {
			var formatDate = moment(dateTime).format("MM.DD");			
			return formatDate;
		},
		getUnitStudyResultName(resultKey) {
			var resultName = "학습 미완료";

			if(resultKey > 0) {
				resultName = "학습 완료";
			}

			return resultName;
		},	
		setPreviewExamImage(examKey, examType) {
			const _this = this;
			var imgExamUrl = MODULE.Util.getExamPrintImgUrl(examKey, examType, "exam");			
			_this.imgExamSrc = imgExamUrl;

			var imgExamViewUrl = "";

			if(examType == "obj") {
				imgExamViewUrl = MODULE.Util.getExamPrintImgUrl(examKey, examType, "objective");
				_this.imgExamViewSrc = imgExamViewUrl;
			}

			_this.$f7.popup.open(".exam-perview-popup",true);
		},	
		studyPlanWeekPage() {
			const _this = this;
			var url = PAGES.MENU_CCM_STUDY_PLAN_WEEK;

			var param = {
				plannerKey : _this.plannerManager.plannerKey,
				weekNo : _this.plannerManager.weekNo,
				groupKey : _this.plannerManager.groupKey,
				gradeId : _this.plannerManager.gradeId,
				reviseId : _this.plannerManager.reviseId,
				semesterId : _this.plannerManager.semesterId,							
			}
			
			PAGES.goPage(url,param);
		},
		studyPlanMonthPage() {
			const _this = this;				
			var url = PAGES.MENU_CCM_STUDY_PLAN_MONTH;

			var param = {
				plannerKey : _this.plannerKey,
				weekNo : _this.weekNo,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId
			};  
			
			PAGES.goPage(url,param);
		},
		dashBoardPage() { // test
			const _this = this;
			var url = PAGES.MENU_CCM_COURSE_LIST;
			PAGES.goPage(url);
		},
	
	
	}
}
</script>